import { Typography, Box, useTheme, useMediaQuery } from '@mui/material'
import { DataGrid } from 'Components/LifeDataGrid'
import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
import { useFocusHighlight, FOCUS_ROW_CLASS, focusRowSx } from 'utils/useFocusHighlight' // LAP — deep-link

function ListOperations({
  fetchOperations,
  operations,
  setSelectedRows,
  setListeTaskId,
  setListeTaskName,
}) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [modifiedColumns, setModifiedColumns] = useState([])
  // LAP — surligne la liste ciblée par la recherche globale (?focus=<id>)
  const { isFocused } = useFocusHighlight()

  let navigate = useNavigate()
  const [rows, setRows] = useState(20)
  const [page, setPage] = useState(0)
  const handleRowsChange = (newPageSize) => {
    setRows(newPageSize)
    let url = `&limit=${newPageSize}&offset=${page}`
    fetchOperations(url)
  }
  const handlePageChange = (newPage) => {
    setPage(newPage * rows)
    let url = `&limit=${rows}&offset=${newPage * rows}`
    fetchOperations(url)
  }
  useEffect(() => {
    if (isMobile) {
      // LAP — carte mobile pleine largeur : nom de la liste + avancement des
      // tâches en puce, domaine en méta. Une seule colonne = plus de scroll
      // horizontal.
      setModifiedColumns([
        {
          field: 'Nom',
          headerName: t('mesToDo.colName'),
          flex: 1,
          minWidth: 240,
          renderCell: (params) => {
            const taskslist = params.row.tasks || []
            let done = 0
            taskslist.forEach((v) => {
              if (v.Done) done++
            })
            return (
              <Box sx={{ width: '100%', py: '10px' }}>
                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                  <Box
                    sx={{
                      fontWeight: 700,
                      fontSize: '15px',
                      flex: 1,
                      whiteSpace: 'normal',
                      lineHeight: 1.3,
                    }}
                  >
                    {params.row.Name}
                  </Box>
                  <Box
                    sx={{
                      fontSize: '12px',
                      fontWeight: 600,
                      color: '#1d4ed8',
                      background: '#dbeafe',
                      borderRadius: '999px',
                      padding: '2px 10px',
                      whiteSpace: 'nowrap',
                      flexShrink: 0,
                    }}
                  >
                    {t('mesToDo.colTasks')} {done}/{taskslist.length}
                  </Box>
                </Box>
                {params.row.LifeDomain && params.row.domain?.domain && (
                  <Box sx={{ marginTop: '6px', fontSize: '13px', color: '#64748b' }}>
                    {params.row.domain.domain}
                  </Box>
                )}
              </Box>
            )
          },
        },
      ])
    } else {
      setModifiedColumns(columns)
    }
  }, [isMobile])
  const columns = [
    {
      field: 'Name',

      headerName: t('mesToDo.colName'),
      width: 650,
      editable: true,
      renderCell: (params) => params.row.Name,
    },
    {
      field: 'LifeDomain',
      headerName: t('mesToDo.fieldDomain'),
      width: 90,
      editable: true,
      valueGetter: (params) => `${params.row.LifeDomain ? params.row.domain.domain : ''}`,
    },
    {
      headerName: t('mesToDo.colTasks'),
      width: 80,
      editable: true,
      renderCell: (params) => {
        let done = 0
        let taskslist = params.row.tasks
        taskslist.map((v) => {
          if (v.Done) done++
          return ''
        })
        let text = done + '/' + taskslist.length
        return <Box>{text}</Box>
      },
    },

    {
      field: '',
      headerName: t('mesToDo.fieldProject'),
      width: 90,
      editable: true,
      renderCell: (params) => {
        return <Box>0</Box>
      },
    },
  ]

  return (
    <div
      style={{
        height: 750,
        width: '100% ',
        background: 'white',
        borderRadius: '14px', // LAP — cohérent avec les cartes de la synthèse
        overflow: 'hidden',
        paddingBottom: 54,
      }}
    >
      <Typography
        variant="h6"
        sx={{
          flex: '1 1 100%',
          id: 'tableTitle',
          fontWeight: 600,
          padding: '10px',
          component: 'div',
        }}
      >
        {t('mesToDo.listsTitle', { count: operations.count })}
      </Typography>

      <DataGrid
        sx={{
          '.MuiDataGrid-footerContainer': { background: 'aliceblue' },
          '.MuiTablePagination-toolbar': { alignItems: 'baseline' },
          ...focusRowSx, // LAP — surlignage deep-link
        }}
        rows={operations.results ? operations.results : []}
        columns={modifiedColumns}
        pageSize={rows}
        getRowClassName={(params) => (isFocused(params.id) ? FOCUS_ROW_CLASS : '')}
        rowCount={operations.count ? operations.count : 0}
        getRowHeight={() => (isMobile ? 'auto' : 50)}
        onPageSizeChange={handleRowsChange}
        onPageChange={handlePageChange}
        rowsPerPageOptions={[10, 20, 40, 80, 100]}
        pagination
        onSelectionModelChange={(itm) => setSelectedRows([...itm])}
        paginationMode="server"
        checkboxSelection
        disableSelectionOnClick
        onRowClick={(params, event) => {
          // LAP — guard robuste : on navigue sauf si le tap vient d'un élément
          // interactif (checkbox…). L'ancien test localName === 'div' ignorait
          // les taps sur le texte/spans → double-tap nécessaire sur mobile.
          if (event.target.closest && event.target.closest('input, button, a, label')) return
          setListeTaskId(params.id)
          setListeTaskName(params.row.Name)
          navigate('/todos/taches')
        }}
      />
    </div>
  )
}
export default ListOperations
